import { render, staticRenderFns } from "./admin-teachers.vue?vue&type=template&id=5ddbb891&scoped=true"
import script from "./admin-teachers.vue?vue&type=script&lang=js"
export * from "./admin-teachers.vue?vue&type=script&lang=js"
import style0 from "./admin-teachers.vue?vue&type=style&index=0&id=5ddbb891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddbb891",
  null
  
)

export default component.exports